import { render, staticRenderFns } from "./Ecovalor.vue?vue&type=template&id=7142ea11"
import script from "./Ecovalor.vue?vue&type=script&lang=js"
export * from "./Ecovalor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports